import { VStack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const SubscriptionsPage = () => {
    const { t } = useTranslation("subscriptions");
    return (
        <VStack w="full" py={12} alignItems="flex-start">
            <Text fontSize="2xl" fontWeight="bold">{t("subscriptionsPage.title")}</Text>
            <Text color="text.muted">{t("subscriptionsPage.comingSoon")}</Text>
        </VStack>
    );
};

export default SubscriptionsPage;
